<template>
  <div
    class="con-vs-chip"
    :class="[
      `vs-chip-${color}`,
      {
        closable,
        'con-color': color,
        'bg-chip-transparent': transparent,
      },
    ]"
    :style="chipStyle"
  >
    <span class="text-chip vs-chip--text"><slot /></span>
    <button
      v-if="closable"
      class="btn-close vs-chip--close"
      type="button"
      @click="closeChip"
    >
      <vs-icon :icon-pack="iconPack" :icon="closeIcon" />
    </button>
  </div>
</template>

<script>
function resolveColor(color, opacity = 1) {
  if (!color) return null;
  if (color.startsWith("#")) {
    const normalized = color.replace(
      /^#?([a-f\d])([a-f\d])([a-f\d])$/i,
      (_, red, green, blue) => red + red + green + green + blue + blue
    );
    const match = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(
      normalized
    );
    if (!match) return color;
    const channels = match.slice(1).map((channel) => parseInt(channel, 16));
    return opacity === 1
      ? `rgb(${channels.join(",")})`
      : `rgba(${channels.join(",")},${opacity})`;
  }
  if (
    color.startsWith("rgb") ||
    color.startsWith("hsl") ||
    color.startsWith("var(")
  ) {
    return color;
  }
  return `rgba(var(--vs-${color}), ${opacity})`;
}

export default {
  name: "VsChip",
  props: {
    modelValue: {
      default: undefined,
    },
    value: {
      default: undefined,
    },
    item: {
      type: Boolean,
      default: false,
    },
    active: {
      type: Boolean,
      default: true,
    },
    text: {
      type: String,
      default: null,
    },
    closable: {
      type: [Boolean, String],
      default: false,
    },
    color: {
      type: String,
      default: null,
    },
    icon: {
      type: String,
      default: null,
    },
    iconPack: {
      type: String,
      default: "material-icons",
    },
    closeIcon: {
      type: String,
      default: "clear",
    },
    transparent: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:modelValue", "input", "click", "vs-remove"],
  computed: {
    chipStyle() {
      return {
        background: this.transparent
          ? resolveColor(this.color, 0.15)
          : resolveColor(this.color),
        color: this.transparent
          ? resolveColor(this.color)
          : this.color
          ? "rgba(255,255,255,.9)"
          : "rgba(0,0,0,.7)",
      };
    },
  },
  methods: {
    emitValue(value) {
      this.$emit("update:modelValue", value);
      this.$emit("input", value);
    },
    closeChip() {
      this.emitValue(false);
      this.$emit("click");
    },
    remove() {
      this.$emit("vs-remove", false);
      this.emitValue(false);
    },
  },
};
</script>
